import { render, staticRenderFns } from "./POSReport.vue?vue&type=template&id=3beba7a3"
import script from "./POSReport.vue?vue&type=script&lang=js"
export * from "./POSReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports